import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
  createTreeMultiFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { createActionsColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import {
  formatMtrKindLabel,
  formatOriginalSerialList,
  MTR_KIND_FILTER_OPTIONS,
} from '#/modules/imsMgmt/settings/mtr/helper/mtrFilterOptions';

export function buildMtrAssemblyColumns({ onRemove }) {
  return [
    {
      header: '料號',
      accessorKey: 'mtrNo',
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 200,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableSorting: false,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
    },
    createActionsColumn({
      size: 80,
      minSize: 80,
      getActions: (row) => ([
        {
          key: 'remove',
          label: '移除',
          destructive: true,
          onClick: () => onRemove(row.optionMtrId),
        },
      ]),
    }),
  ];
}

export function buildMtrPickerColumns({
  filters = {},
  onFilterChange,
  includeMtrKindColumn = false,
} = {}) {
  const mtrKindColumn = includeMtrKindColumn
    ? [{
      id: 'mtrKind',
      header: '類型',
      accessorKey: 'mtrKind',
      size: 112,
      enableSorting: false,
      enableColumnFilter: true,
      cell: ({ getValue }) => formatMtrKindLabel(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'mtrKind',
        label: '類型',
        options: MTR_KIND_FILTER_OPTIONS,
        filterValue: filters.mtrKind,
        onChange: (value) => onFilterChange('mtrKind', value),
      }),
    }]
    : [];

  return [
    {
      header: '料號',
      accessorKey: 'mtrNo',
      size: 120,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'mtrNo',
          label: '料號',
          filterValue: filters.mtrNo,
          onChange: (value) => onFilterChange('mtrNo', value),
          placeholder: '搜尋料號',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.mtrNo || '—'} />
      ),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 160,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    ...mtrKindColumn,
    {
      id: 'mtrStructMain',
      header: '主分類',
      accessorFn: (row) => row.mtrStructMain?.name ?? '-',
      size: 100,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTreeMultiFilterMeta({
        key: 'mtrStructMainId',
        label: '主分類',
        treeRole: 'main',
        filterValue: filters.mtrStructMainId,
        onChange: (value) => onFilterChange('mtrStructMainId', value),
      }),
    },
    {
      id: 'mtrStructSub',
      header: '次分類',
      accessorFn: (row) => row.mtrStructSub?.name ?? '-',
      size: 100,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTreeMultiFilterMeta({
        key: 'mtrStructSubId',
        label: '次分類',
        treeRole: 'sub',
        filterValue: filters.mtrStructSubId,
        onChange: (value) => onFilterChange('mtrStructSubId', value),
      }),
    },
    {
      id: 'originalSerialList',
      header: '原廠料號',
      accessorFn: (row) => formatOriginalSerialList(row.originalSerialList),
      size: 140,
      enableSorting: true,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'originalSerialList',
          label: '原廠料號',
          filterValue: filters.originalSerialList,
          onChange: (value) => onFilterChange('originalSerialList', value),
          placeholder: '搜尋原廠料號',
        }),
      },
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 80,
      enableSorting: false,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
    },
  ];
}
